import { gql } from 'gql/__generated__'

export const templatesGetAllQuery = gql(`
  query TemplatesAll($companyId: ID!, $data: EditorTemplateAllInput!) {
    data: editorTemplatesAll(companyId: $companyId, data: $data) {
      templates {
        ...TemplatesListSchema
      }
      pagination {
        limit
        offset
        total
      }
    }
  }
`)

export const templatesGetGroupAll = gql(`
  query EditorTemplateCollections(
    $companyId: ID!
    $data: TemplateCollectionSearch!
    $mode: [BlockModeEnum!]
  ) {
    data: templateCollections(companyId: $companyId, search: $data) {
      templateCollections {
        ...TemplateCollectionsSchemaCount
      }
    }
  }
`)

export const templatesGetTemplatesAndCollections = gql(`
  query EditorTemplatesAndCollections(
    $companyId: ID!
    $data: TemplatesAndCollectionsSearch!
    $mode: [BlockModeEnum!]
  ) {
    data: templatesAndCollections(companyId: $companyId, search: $data) {
      templateCollections {
        ...TemplateCollectionsSchemaCount
      }
      templates {
        ...TemplatesListSchema
      }
    }
  }
`)

export const editorTemplatesAllTotal = gql(`
  query EditorTemplatesAllTotal($search: EditorTemplatesAllTotalInput!) {
    data: editorTemplatesAllTotal(search: $search) {
      favorites
      archived
    }
  }
`)

export const templateTagsByCollection = gql(`
  query TemplateTagsByCollection(
    $companyId: ID!
    $collectionId: ID!
    $filter: TemplateTagsFilter
  ) {
    data: templateTagsByCollection(
      companyId: $companyId
      collectionId: $collectionId
      filter: $filter
    ) {
      templateTags {
        ...TemplateTagsSchema
      }
    }
  }
`)
